import _ from 'lodash'
import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { name } from '../symbols'
import type { ISeoSiteApi } from '../types'
import { FeatureExportsSymbol } from '@wix/thunderbolt-symbols'
import { IFeatureExportsStore } from 'thunderbolt-feature-exports'

type FunctionNames = keyof ISeoSiteApi
type ISeoSiteApiNoop = {
	[k in FunctionNames]: () => void
}

export const SeoEditor = withDependencies(
	[named(FeatureExportsSymbol, name)],
	(seoExports: IFeatureExportsStore<typeof name>): ISeoSiteApiNoop => {
		const noop = _.noop
		const setVeloSeoTags = () => Promise.resolve()
		const resetVeloSeoTags = () => Promise.resolve()

		seoExports.export({ setVeloSeoTags, resetVeloSeoTags })

		return {
			getPageTitle: noop,
			getRedirectUrl: noop,
			getSeoStatusCode: noop,
			getSiteLevelSeoData: noop,
			isInSEO: noop,
			onTPAOverridesChanged: () => noop,
			renderSEO: noop,
			renderSEODom: noop,
			resetTpaAndVeloData: noop,
			resetTPAEndpointData: noop,
			resetVeloSeoTags,
			setDynamicRouteOverrides: noop,
			setPageData: noop,
			setPageHref: noop,
			setPageId: noop,
			setRedirectUrl: noop,
			setTPAEndpointData: noop,
			setTPAOverrides: noop,
			setVeloLinks: noop,
			setVeloMetaTags: noop,
			setVeloSeoStatusCode: noop,
			setVeloSeoTags,
			setVeloStructuredData: noop,
			setVeloTitle: noop,
		}
	}
)
